export default __webpack_public_path__ + "static/media/asidelogo.5197bb1b.svg";